<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title mb-0">Cloudflare Enterprise Domains</h4>
            <!-- Status Count -->
            <div class="row mb-0 mt-3 mb-10 cf-ent-status-row flex-nowrap">
              <div class="col">
                <div
                  class="status-item status-item-pending"
                  @click="setTab('pending')"
                >
                  <i class="fa fa-clock-o status-icon status-icon-pending"></i>
                  <div class="status-content">
                    <div class="status-label">Pending</div>
                    <div class="status-count">
                      <i v-if="loading" class="fa fa-spin fa-spinner status-label"></i>
                      <span v-else>{{ tabCounts.pending }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div
                  class="status-item status-item-inprogress"
                  @click="setTab('inProgress')"
                >
                  <i class="fa fa-spinner status-icon status-icon-inprogress"></i>
                  <div class="status-content">
                    <div class="status-label">In Progress</div>
                    <div class="status-count">
                      <i v-if="loading" class="fa fa-spin fa-spinner status-label"></i>
                      <span v-else>{{ tabCounts.inProgress }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div
                  class="status-item status-item-complete"
                  @click="setTab('complete')"
                >
                  <i class="fa fa-check-circle status-icon status-icon-complete"></i>
                  <div class="status-content">
                    <div class="status-label">Complete</div>
                    <div class="status-count">
                      <i v-if="loading" class="fa fa-spin fa-spinner status-label"></i>
                      <span v-else>{{ tabCounts.complete }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div
                  class="status-item status-item-deferred"
                  @click="setTab('deferred')"
                >
                  <i class="fa fa-pause status-icon status-icon-deferred"></i>
                  <div class="status-content">
                    <div class="status-label">Deferred</div>
                    <div class="status-count">
                      <i v-if="loading" class="fa fa-spin fa-spinner status-label"></i>
                      <span v-else>{{ tabCounts.deferred }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div
                  class="status-item status-item-followup"
                  @click="setTab('followUp')"
                >
                  <i class="fa fa-flag status-icon status-icon-followup"></i>
                  <div class="status-content">
                    <div class="status-label">Follow Up</div>
                    <div class="status-count">
                      <i v-if="loading" class="fa fa-spin fa-spinner status-label"></i>
                      <span v-else>{{ tabCounts.followUp }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div
                  class="status-item status-item-failed"
                  @click="setTab('failed')"
                >
                  <i class="fa fa-times-circle status-icon status-icon-failed"></i>
                  <div class="status-content">
                    <div class="status-label">Failed</div>
                    <div class="status-count">
                      <i v-if="loading" class="fa fa-spin fa-spinner status-label"></i>
                      <span v-else>{{ tabCounts.failed }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ul class="nav nav-tabs" id="cfEntTabs" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ active: activeTab === 'pending' }"
                  href="#pending"
                  role="tab"
                  @click.prevent="setTab('pending')"
                >Pending</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ active: activeTab === 'inProgress' }"
                  href="#inProgress"
                  role="tab"
                  @click.prevent="setTab('inProgress')"
                >In Progress</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ active: activeTab === 'complete' }"
                  href="#complete"
                  role="tab"
                  @click.prevent="setTab('complete')"
                >Complete</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ active: activeTab === 'deferred' }"
                  href="#deferred"
                  role="tab"
                  @click.prevent="setTab('deferred')"
                >Deferred</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ active: activeTab === 'followUp' }"
                  href="#followUp"
                  role="tab"
                  @click.prevent="setTab('followUp')"
                >Follow Up</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ active: activeTab === 'failed' }"
                  href="#failed"
                  role="tab"
                  @click.prevent="setTab('failed')"
                >Failed</a>
              </li>
            </ul>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-md-12 mt-10">
                <div class="d-flex align-items-center flex-wrap" style="gap: 4px">
                  <label class="fw-600 mr-3 mb-0">Filter:</label>
                  <button
                    v-for="(filter, index) in priorityPlanFilters"
                    :key="index"
                    type="button"
                    class="btn btn-sm priority-filter-btn"
                    :class="getPlanFilterButtonClass(filter)"
                    @click="selectedPlanFilter = selectedPlanFilter === filter ? null : filter"
                  >
                    {{ filter }}
                  </button>
                </div>
              </div>
            </div>
            <template v-if="activeTab !== 'pending'">
              <div class="row">
                <div class="col-md-12">
                  <div class="d-flex align-items-center mb-10 flex-wrap">
                    <label class="fw-600 mr-3 mb-0">Checkin Filter:</label>
                    <button
                      :class="checkinFilter === 'all' ? 'btn-primary' : 'btn-primary btn-link'"
                      type="button"
                      class="btn btn-sm ml-2"
                      @click="checkinFilter = 'all'"
                    >
                      <img class="rounded-circle mr-2" width="20px" height="20px" :src="`https://www.gravatar.com/avatar/${emailHashGravatar('')}?s=100`" alt="">
                      All
                    </button>
                    <button
                      :class="checkinFilter === `${user.firstName} ${user.lastName}` ? 'btn-primary' : 'btn-primary btn-link'"
                      type="button"
                      class="btn btn-sm ml-2"
                      @click="checkinFilter = `${user.firstName} ${user.lastName}`"
                    >
                      <img class="rounded-circle mr-2" width="20px" height="20px" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(user.email)}?s=100`" :alt="user.name">
                      {{ user.firstName}}
                    </button>
                  </div>
                </div>
              </div>
            </template>
            <div v-if="activeTab === 'pending'" class="d-flex justify-content-end mb-2">
              <button class="btn btn-sm btn-outline-primary" @click="openNonWpoModal">
                <i class="fa fa-plus mr-1"></i> Initiate Boost for Non-WPO
              </button>
            </div>
            <div class="row pb-10">
              <div class="col-md-2">
                <label class="d-flex align-items-center"> Show
                  <select id="grouped"
                          v-model="pageMainSize"
                          aria-describedby="grouped"
                          class="mr-7 ml-7 custom-select custom-select-sm form-control form-control-sm datatable-dropdown"
                          required style="width: 65px;">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option :value="sortedDomains.length">All</option>
                  </select> entries</label>
              </div>
              <div class="col-md-8"></div>
              <div class="col-md-2 pull-left">
                <input v-model="searchQuery" class="form-control mr-5" placeholder="Search" style="height: 30px;"
                       type="text"/>
              </div>
            </div>
            <div v-if="loading" class="text-center py-5">
              <i class="fa fa-spinner fa-spin fa-3x text-primary"></i>
              <p class="mt-3 mb-0">Loading domains...</p>
            </div>
            <table v-else id="datatable" class="table table-striped table-bordered">
              <thead class="thead-dark">
              <tr>
                <th width="5%"></th>
                <th width="10%">Domain</th>
                <th class="text-center" width="8%">Server IP</th>
                <th class="text-center" width="10%">Plan</th>
                <th class="text-center" width="13%">Note</th>
                <th class="text-center" width="5%">Is Activated</th>
                <th class="text-center" width="5%">O20 Status</th>
                <th class="text-center" width="5%">Activated At</th>
                <th class="text-center" width="5%">CF Ent IP</th>
                <th class="text-center" width="5%">Check In</th>
                <th class="text-center" v-if="activeTab !== 'pending' || activeTab === 'followUp'">Action</th>
              </tr>
              </thead>
              <tbody v-for="(row, index) in paginatedDomains" :key="row.id">
              <tr>
                <td>
                  <span
                      :class="{ 'details-control shown' : openDetails === row.id, 'details-control' : openDetails !== row.id }"
                      @click="openDetails === row.id ? openDetails = null : openDetails = row.id; checkDnsAndNameServer(row)"></span>
                </td>
                <td>
                  {{ row.domain }}
                  <i v-if="row.nonWpo" class="fa fa-ban ml-1 text-danger" title="Not in WPO" data-toggle="tooltip" style="font-size:11px;cursor:default;"></i>
                </td>
                <td class="text-center" width="10%">
                  {{ row.ip || '' }}
                </td>
                <td width="20%">
                  <template>
                    <div class="d-flex align-items-center">
                      <select v-model="row.cfPlan" class="form-control">
                        <option value="performance_package">Performance Package</option>
                        <option disabled value="security_package">Security Package</option>
                        <option value="performance_and_security_package">Performance & Security Package</option>
                        <option value="boost">Boost</option>
                        <option disabled value="maintenance_I">Maintenance I</option>
                        <option disabled value="maintenance_II">Maintenance II</option>
                        <option disabled value="maintenance_III">Maintenance III</option>
                        <option value="mediavine_integration">Mediavine Integration</option>
                      </select>
                      <span><i class="fa fa-save text-primary ml-10 make-cursor-pointer"
                               title="Save"
                               @click="selectedIndex = index; action='changePlan';setCFPlanInHostingAccounts(row, true)"></i><i
                          v-if="index === selectedIndex && action === 'changePlan'"
                          class="fa fa-spinner fa-spin text-primary ml-10 make-cursor-pointer"></i></span>
                    </div>

                  </template>
                </td>
                <td width="5%" class="make-cursor-pointer" style="max-width: 5px" @click="openModal(row)">
                  <span>{{ row.cfEnterprise && row.cfEnterprise.note ? row.cfEnterprise.note : 'N/A' }}</span>
                  <a title="View Ticket" data-toggle="tooltip" class="ml-5" v-if="row.cfEnterprise.ticketId" target="_blank" :href="`https://www.bigscoots.com/portal/admin/?cmd=tickets&action=view&brc=MTA&list=requirescustomerupdate&num=${row.cfEnterprise.ticketId}`"><i class="fa fa-ticket"></i></a>

                </td>
                <td class="text-center fs-16">
                  <i :class="row.cfEnterprise.status === 'pass' || row.cfEnterprise.previousStatus === 'pass' ? 'fa fa-check-circle text-success' : (row.cfEnterprise.status === 'running' ? 'fa fa-spinner fa-spin text-info' : (row.cfEnterprise.status === 'fail' ? 'fa fa-exclamation-circle text-warning' : 'fa fa-times-circle text-danger'))"
                     :title="(row.cfEnterprise.status === 'fail') ? 'One or more steps have failed during the setup process.' : ''"></i>
                </td>
                <td class="text-center fs-16">
                  <i :class="row.cfEnterprise.o2o_status ? 'fa fa-check-circle text-success' : 'fa fa-times-circle text-danger'"></i>
                </td>
                <td class="text-center">
                  {{
                    row.cfEnterprise.activatedAt === 'Not enabled by WPO' ? 'Activation Date Not Available' : parseDate(row.cfEnterprise.activatedAt)
                  }}
                </td>
                <td>
                  <div class="d-flex justify-content-between align-items-center">
                    <div v-if="!updateIp[row.id]" class="d-flex">
                      <span  class="mr-5 badge bg-light text-dark border">
                        CF Ent IP: <strong>{{ row.cfEntIp || 'N/A' }}</strong>
                      </span>
                      <button @click="$set(updateIp, row.id, true)" type="button" class="nav-link btn btn-link btn-sm btn-info pt-0 pb-0 pr-6 pl-7">
                        <i class="fa fa-pencil"></i>
                      </button>
                      <button :disabled="updateIpLoader[row.id]" @click="getIp(row)" type="button" class="nav-link btn btn-link btn-sm btn-primary pt-0 pb-0 pr-6 pl-7">
                        <i :class="updateIpLoader[row.id] ? 'fa-spin fa-spinner' : 'fa-refresh'" class="fa fa-refresh"></i>
                      </button>
                    </div>
                    <div v-if="updateIp[row.id]" class="d-flex">
                      <input @keydown.space.prevent v-model="row.cfEntIp" type="text" class="form-control">
                      <span class="ml-5">
                        <i @click="updateIP(row)" :class="updateIpLoader[row.id] ? 'fa-spin fa-spinner' : 'fa-save'" class="fa text-primary"></i>
                        <i @click="$set(updateIp, row.id, false)" class="fa fa-ban text-danger"></i>
                      </span>
                    </div>
                  </div>
                </td>
                <td width="12%" class="text-center">
                  <button v-if="!row.cfEnterprise.checkinBy && activeTab !== 'complete'" class="btn btn-sm btn-primary mr-5" data-toggle="tooltip"
                          title="Checkin" @click="checkin(row, index)">
                    <span v-if="action === 'checkin' && selectedIndex === index"><i class="fa fa-spinner fa-spin"></i></span>
                    <span v-else>Check In</span>
                  </button>
                  <div style="display:inline-flex;flex-direction:column;align-items:flex-start;gap:6px;">
                    <div v-if="row.cfEnterprise.checkinByEmail" style="display:flex;align-items:center;gap:6px;background:#f8f9fa;border-radius:20px;padding:3px 8px 3px 3px;" :title="`Started by ${row.cfEnterprise.checkinBy}`" data-toggle="tooltip">
                      <span class="position-relative d-inline-block">
                        <img width="26px" height="26px" class="rounded-circle" style="border:2px solid #51cbce;" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.cfEnterprise.checkinByEmail)}?s=120`">
                        <span v-if="activeTab === 'inProgress'" @click="checkout(row, index)" title="Checkout" data-toggle="tooltip" style="position:absolute;top:-3px;right:-3px;width:13px;height:13px;background:#dc3545;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:9px;color:#fff;line-height:1;">×</span>
                      </span>
                      <div style="display:flex;flex-direction:column;line-height:1.2;">
                        <span style="font-size:9px;color:#51cbce;font-weight:700;text-transform:uppercase;letter-spacing:0.3px;">Started By</span>
                        <span style="font-size:10px;font-weight:600;color:#555;white-space:nowrap;max-width:60px;overflow:hidden;text-overflow:ellipsis;">{{ row.cfEnterprise.checkinBy ? row.cfEnterprise.checkinBy.split(' ')[0] : '' }}</span>
                      </div>
                    </div>
                    <div v-if="row.cfEnterprise.resolvedByEmail" style="display:flex;align-items:center;gap:6px;background:#f0faf4;border-radius:20px;padding:3px 8px 3px 3px;" :title="`Resolved by ${row.cfEnterprise.resolvedBy}`" data-toggle="tooltip">
                      <img width="26px" height="26px" class="rounded-circle" style="border:2px solid #6bd098;" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.cfEnterprise.resolvedByEmail)}?s=120`">
                      <div style="display:flex;flex-direction:column;line-height:1.2;">
                        <span style="font-size:9px;color:#6bd098;font-weight:700;text-transform:uppercase;letter-spacing:0.3px;">Resolved By</span>
                        <span style="font-size:10px;font-weight:600;color:#555;white-space:nowrap;max-width:60px;overflow:hidden;text-overflow:ellipsis;">{{ row.cfEnterprise.resolvedBy ? row.cfEnterprise.resolvedBy.split(' ')[0] : '' }}</span>
                      </div>
                    </div>
                  </div>

<!--                  <span v-if="true" :title="row.cfEnterprise.resolvedBy ? `Resolved by ${row.cfEnterprise.resolvedBy}` : `Checked in by ${row.cfEnterprise.checkinBy}`" data-toggle="tooltip">-->
<!--                    <button v-if="!row.cfEnterprise.resolvedBy" :disabled="checkBeforeResolveTask(row.cfEnterprise)" class="btn btn-sm btn-info mr-5 make-cursor-pointer"-->
<!--                            @click="resolve(row, index)">-->
<!--                      <span v-if="action === 'resolve' && selectedIndex === index"><i class="fa fa-spinner fa-spin"></i></span>-->
<!--                      <span v-else>Resolve</span>-->
<!--                    </button>-->
<!--                    <button v-else disabled class="btn btn-sm btn-info mr-5 make-cursor-pointer">-->
<!--                      Resolved-->
<!--                    </button>-->
<!--                  </span>-->
                </td>
                <td  v-if="activeTab !== 'pending' || activeTab === 'followUp'" class="text-center">
                  <div class="dropdown m-auto">
                    <button :disabled="action === 'initPKey' && selectedIndex === index" id="dropdownMenuButton1" aria-expanded="false"
                            aria-haspopup="true" class="btn btn-sm btn-link dropdown-toggle" data-toggle="dropdown"
                            title="Choose Operation" type="button">
                      <span v-if="action === 'initPKey' && selectedIndex === index"><i class="fa fa-spinner fa-spin ml-3"></i></span>
                      <i v-else class="fa fa-cog"></i>
                    </button>
                    <div aria-labelledby="dropdownMenuButton1" class="dropdown-menu dropdown-menu-right">
                      <a @click="resolve(row, index)" v-if="row.cfEnterprise.cfEntChecklist && row.cfEnterprise.cfEntChecklist.every(el => el.isChecked) || activeTab === 'inProgress' || activeTab === 'failed'" :disabled="checkBeforeResolveTask(row.cfEnterprise)" href="javascript:void(0)" class="dropdown-item">
                        <span v-if="action === 'resolve' && selectedIndex === index"><i class="fa fa-spinner fa-spin"></i></span>
                        <span v-else>
                          <i style="color: green" class="fa fa-check-circle"></i>
                        </span>
                        <span class="ml-5">Resolve</span>

                      </a>
                      <a @click="addChecklist(row, index)" v-if="!row.cfEnterprise.cfEntChecklist" href="javascript:void(0)" class="dropdown-item">
                        <span v-if="action === 'addChecklist' && selectedIndex === index"><i class="fa fa-spinner fa-spin"></i></span>
                        <span v-else>
                          <i style="color: green" class="fa fa-plus"></i>
                        </span>
                        <span class="ml-5">Add checklist</span>

                      </a>
                      <a v-if="(row.cfPlan === 'mediavine_integration' || row.cfPlan === 'boost') && !row.cfEnterprise.ticketId && !row.nonWpo" :disabled="openTicketLoader[row.id]" @click="openTicketForBoostOrMediavineIntegrationPlan(row, index)" class="dropdown-item" href="javascript:void(0)" ><i class="fa fa-ticket text-primary mr-5"></i>1-Click Ticket</a>
                      <a class="dropdown-item" href="javascript:void(0)"  @click="initiatePKeyProcess(row, index)" v-if="row.cfEnterprise.status === 'pending'">
                        <span v-if="action === 'initPKey' && selectedIndex === index"><i class="fa fa-spinner fa-spin ml-3"></i></span>
                        <span v-else><i class="fa fa-flash text-warning make-cursor-pointer ml-3"></i></span>
                        <span class="ml-8">Initialize</span>
                      </a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="viewLogs(row.cfEnterprise)">
                        <i class="fa fa-eye text-info mr-5"></i>View Output
                      </a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="loginAsUser(row, index)">
                        <i class="fa fa-user text-success mr-6"></i>
                        <span>Login as user</span>
                      </a>
                      <a @click="retry(row, index)" class="dropdown-item" href="javascript:void(0)" v-if="row.cfEnterprise.status === 'fail' || row.cfEnterprise.status === 'failed'">
                        <span v-if="action === 'retry' && selectedIndex === index"><i
                          class="fa fa-spinner fa-spin"></i>
                        </span>
                        <span v-else><i class="fa fa-repeat text-warning make-cursor-pointer"></i></span>
                        <span class="ml-5">Retry</span>
                      </a>
                      <a v-if="activeTab === 'pending' || activeTab === 'inProgress'" @click="moveToFollowUp(row, index)" class="dropdown-item" href="javascript:void(0)">
                        <span v-if="action === 'followUp' && selectedIndex === index"><i class="fa fa-spinner fa-spin"></i></span>
                        <span v-else><i class="fa fa-flag" style="color:#ffc107;"></i></span>
                        <span class="ml-5">Move to Follow Up</span>
                      </a>
                      <a v-if="activeTab === 'followUp'" @click="moveToFollowUp(row, index, true)" class="dropdown-item" href="javascript:void(0)">
                        <span v-if="action === 'followUp' && selectedIndex === index"><i class="fa fa-spinner fa-spin"></i></span>
                        <span v-else><i class="fa fa-undo text-secondary"></i></span>
                        <span class="ml-5">Remove Follow Up</span>
                      </a>
                      <a @click="deactivate(row, index)" class="dropdown-item" href="javascript:void(0)">
                        <span v-if="action === 'deactivate' && selectedIndex === index"><i
                            class="fa fa-spinner fa-spin"></i></span>
                        <span v-else><i class="fa fa-ban text-danger make-cursor-pointer"></i></span>
                        <span class="ml-5">Deactivate</span>
                      </a>
                      <a v-if="row.cfEnterprise.status === 'pass'" @click="change020Status(row, index)" class="dropdown-item" href="javascript:void(0)">
                        <span v-if="action === 'changeO2O' && selectedIndex === index"><i class="fa fa-spinner fa-spin"></i></span>
                        <span v-else><i class="fa fa-edit text-primary"></i></span>
                        <span class="ml-5">Modify O2O </span>
                      </a>
                    </div>
                  </div>

<!--                  <button v-if="( row.cfPlan === 'mediavine_integration' || row.cfPlan === 'boost') && !row.cfEnterprise.ticketId" :disabled="openTicketLoader[row.id]" @click="openTicketForBoostOrMediavineIntegrationPlan(row, index)" title="1-click ticket" data-toggle="tooltip" class="btn btn-sm btn-default mr-5"><i class="fa fa-ticket"></i></button>-->


<!--                  <template v-if="row.cfEnterprise.status === 'pending'">-->
<!--                    <button class="btn btn-sm btn-warning mr-5"-->
<!--                            title="Initialise process" @click="initiatePKeyProcess(row, index)">-->
<!--                      <span v-if="action === 'initPKey' && selectedIndex === index"><i class="fa fa-spinner fa-spin"></i></span>-->
<!--                      <span v-else><i class="fa fa-flash make-cursor-pointer"></i></span>-->
<!--                    </button>-->

<!--                  </template>-->
<!--                  <button class="btn btn-sm btn-primary" title="View Output" @click="viewLogs(row.cfEnterprise)">-->
<!--                    <span><i class="fa fa-eye make-cursor-pointer"></i></span>-->
<!--                  </button>-->
<!--                  <button class="btn btn-primary btn-sm ml-2" title="Login as user" @click="loginAsUser(row, index)">-->
<!--                    <i class="fa fa-user"></i>-->
<!--                  </button>-->
<!--                  <button v-if="row.cfEnterprise.status === 'fail'" class="btn btn-sm btn-info ml-5"-->
<!--                          title="Retry" @click="retry(row, index)">-->
<!--                    <span v-if="action === 'retry' && selectedIndex === index"><i-->
<!--                        class="fa fa-spinner fa-spin"></i></span>-->
<!--                    <span v-else><i class="fa fa-repeat make-cursor-pointer"></i></span>-->
<!--                  </button>-->
<!--                  <button class="btn btn-sm btn-danger ml-5" title="Deactivate CF Enterprise"-->
<!--                          @click="deactivate(row, index)">-->
<!--                    <span v-if="action === 'deactivate' && selectedIndex === index"><i-->
<!--                        class="fa fa-spinner fa-spin"></i></span>-->
<!--                    <span v-else><i class="fa fa-trash make-cursor-pointer"></i></span>-->
<!--                  </button>-->
<!--                  <button v-if="row.cfEnterprise.status === 'pass'" class="btn btn-sm btn-default grey ml-5"-->
<!--                          title="Change O2O status" @click="change020Status(row, index)">-->
<!--                    <span v-if="action === 'changeO2O' && selectedIndex === index"><i class="fa fa-spinner fa-spin"></i></span>-->
<!--                    <span v-else>O2O</span>-->
<!--                  </button>-->
                </td>
              </tr>
              <tr v-if="row.id === openDetails" class="bg-primary-light">
                <td colspan="11">
                  <section v-if="!row.cfEnterprise.steps">
                    <b v-if="row.cfEnterprise.previousStatus && row.cfEnterprise.previousStatus === 'pass'"
                       class="fw-500">This domain
                      seems to have Cloudflare Enterprise already. Possibly, it was here under a different Cloudflare
                      plan but the new service came through a different name. In this case, if you click on 'Activate'
                      button, WPO will NOT run the script to setup Cloudflare Enterprise again but it will just update
                      the CF Plan name.</b>
                    <template v-else>
                      <b>The setup process has not been initialized yet.</b>
                      <div class="d-flex flex-column">
                        <span class="fw-500">DNS Access:
                        <span v-if="verifyDNSLoader"><i class="fa fa-spin fa-spinner text-primary ml-10"></i></span>
                        <template v-else>
                          <span v-if="dnsVerification" class="text-success ml-10 fw-600 fs-16">True 🤩</span>
                          <span v-else class="text-danger ml-10 fw-600 fs-16">False 😔</span>
                        </template>
                        </span>
                        <span class="fw-500">Nameservers:
                        <span v-if="verifyNameserverLoader"><i class="fa fa-spin fa-spinner text-primary ml-10"></i></span>
                        <template v-else>
                          <span v-if="nameServerVerified" class="text-success ml-10 fw-600 fs-16">True 🤩</span>
                          <span v-else class="text-danger ml-10 fw-600 fs-16">False 😔</span>
                        </template>
                        </span>
                      </div>
                    </template>
                  </section>
                  <section v-else>
                    <template v-if="row.cfEnterprise.steps">
                      <div v-if="row.cfEnterprise.steps && row.cfEnterprise.steps.dns_check" :key="'wb-dns'">
                        <div v-if="row.cfEnterprise.steps.dns_check.data && row.cfEnterprise.steps.dns_check.data.state === 'success'"
                             style="background:#e8f5e9;border:1px solid #a5d6a7;border-left:4px solid #2e7d32;border-radius:6px;padding:10px 14px;margin-bottom:10px;display:flex;align-items:flex-start;gap:10px;text-align:left;">
                          <i class="fa fa-check-circle" style="color:#2e7d32;font-size:18px;margin-top:2px;flex-shrink:0;"></i>
                          <div>
                            <strong style="color:#1b5e20;display:block;">Live on Cloudflare Enterprise</strong>
                            <div v-if="row.cfEnterprise.steps.dns_check.data.monitoring_since" style="font-size:12px;color:#2e7d32;margin-top:4px;">
                              Day {{ Math.min(daysSince(row.cfEnterprise.steps.dns_check.data.monitoring_since), 30) }} of 30
                            </div>
                          </div>
                        </div>
                        <div v-else-if="row.cfEnterprise.steps.dns_check.data && row.cfEnterprise.steps.dns_check.data.state === 'waiting'"
                             style="background:#fff8e1;border:1px solid #ffe082;border-left:4px solid #f9a825;border-radius:6px;padding:10px 14px;margin-bottom:10px;display:flex;align-items:flex-start;gap:10px;text-align:left;">
                          <i class="fa fa-clock-o" style="color:#f9a825;font-size:18px;margin-top:2px;flex-shrink:0;"></i>
                          <div>
                            <strong style="color:#7a5c00;display:block;">Waiting on customer DNS change</strong>
                            <div style="font-size:12px;color:#8a6d00;margin-top:4px;display:flex;gap:16px;flex-wrap:wrap;">
                              <span v-if="row.cfEnterprise.steps.dns_check.data.monitoring_since"><b>Monitoring since:</b> {{ formatStepTime(row.cfEnterprise.steps.dns_check.data.monitoring_since) }}</span>
                              <span v-if="row.cfEnterprise.steps.dns_check.data.checked_at"><b>Last checked:</b> {{ formatStepTime(row.cfEnterprise.steps.dns_check.data.checked_at) }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <div class="row text-left">
                      <div class="col-md-12">
                        <h6 class="text-center"><b>Initialized By: {{ row.cfEnterprise.initializedBy || 'WPO' }}</b></h6>
                      </div>
                    </div>
                    <div>
                      <table class="table">
                        <thead>
                        <tr>
                          <th class="text-left">
                            <div class="text-left"><b>Step</b></div>
                          </th>
                          <th width="10%"><b>Status</b></th>
                          <th width="50%"><b>Responses</b></th>
                        </tr>
                        </thead>
                        <tbody>
                        <!-- Loop through cfEnterprise.steps -->
                        <tr v-for="(el, key) in sortedSteps(row.cfEnterprise.steps)" :key="key">
                          <td class="text-left">
                            <div class="text-left make-cursor-pointer d-flex align-items-center" style="gap:8px;">
                              {{ el.text }}
                              <span v-if="el.data && el.data.dns_mode" style="font-size:10px;font-weight:600;padding:2px 8px;border-radius:99px;background:#e8f4fd;color:#1a73e8;border:1px solid #c5dff8;white-space:nowrap;display:inline-flex;align-items:center;gap:4px;">
                                {{ el.data.dns_mode }}
                                <i v-if="el.data.dns_mode_reason" class="fa fa-info-circle" :title="el.data.dns_mode_reason" data-toggle="tooltip" style="font-size:11px;opacity:.75;"></i>
                              </span>
                            </div>
                          </td>
                          <td width="10%">
                            <span v-if="el.data && el.data.state">
                              <span v-if="el.data.state === 'success'" title="Success">
                                <i class="fa fa-check-circle text-success"></i>
                              </span>
                              <span v-else-if="el.data.state === 'failed'" :title="el.data.reason || 'Failed'">
                                <i class="fa fa-times-circle text-danger"></i>
                                <small v-if="el.data.reason" class="d-block text-danger" style="font-size:10px;max-width:120px;word-break:break-word;">{{ el.data.reason }}</small>
                              </span>
                              <span v-else-if="el.data.state === 'skipped' || el.data.state === 'aborted'" :title="el.data.reason || el.data.state">
                                <i class="fa fa-minus-circle" style="color:#aaa;"></i>
                                <small v-if="el.data.reason" class="d-block text-muted" style="font-size:10px;max-width:120px;word-break:break-word;">{{ el.data.reason }}</small>
                              </span>
                              <span v-else-if="el.data.state === 'waiting'" title="Waiting">
                                <i class="fa fa-clock-o" style="color:#f9a825;"></i>
                              </span>
                              <span v-else>
                                <i class="fa fa-circle-o text-muted"></i>
                              </span>
                            </span>
                            <span v-else>
                              <i :class="el.status === 'pass' ? 'fa fa-check-circle text-success' : (el.status === 'pending' ? 'fa fa-spinner fa-spin text-info' : (el.status === 'fail' ? 'fa fa-exclamation-circle text-warning' : 'fa fa-times-circle text-danger'))"></i>
                            </span>
                          </td>
                          <td class="text-center" width="50%">
                            <div class="text-left">
                              <!-- Show data in a JSON string or format as needed -->
                              <div v-if="viewResponce === `${row.id + key}`" class="json-container">
                                <pre v-if="el.data">
                                  {{ JSON.stringify(el.data, null, 2) }}
                                </pre>
                                <div v-else>
                                  We do not have stored responses for older data.
                                </div>
                              </div>
                              <div style="display: flex; justify-content: space-between">
                                <div>
                                  <a class="make-cursor-pointer text-primary"
                                     @click.prevent="viewResponce === `${row.id + key}` ? viewResponce = null : viewResponce = `${row.id + key}`">
                                    {{ viewResponce === `${row.id + key}` ? "Hide" : "View" }}
                                  </a>
                                  <small v-if="el.data && el.data.state === 'skipped' && el.data.messages && el.data.messages[0]" class="ml-2" style="color:#666;font-style:italic;font-size:11px;font-weight:600;">— {{ el.data.messages[0] }}</small>
                                  <small v-if="el.data && el.data.state === 'aborted' && el.data.errors && el.data.errors[0] && el.data.errors[0].message" class="ml-2" style="color:#c0392b;font-style:italic;font-size:11px;font-weight:600;">— {{ el.data.errors[0].message }}</small>
                                  <span v-if="el.status === 'fail'" class="mx-2">|</span>
                                  <a v-if="el.status === 'fail'" class="make-cursor-pointer text-primary"
                                     @click.prevent="resolveForcefully(row, el.key)">
                                    Resolve Forcefully
                                  </a>
                                </div>
                                <div v-if="el.resolvedForcefully" style="font-size: 13px">
                                  <i>{{ el.resolvedForcefully }}</i>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="row text-left">
                      <div class="col-md-12">
                        <h6><b>Status-Check</b></h6>
                      </div>
                    </div>
                    <div>
                      <table class="table">
                        <thead>
                        <tr>
                          <th class="text-left">
                            <div class="text-left"><b>Step</b></div>
                          </th>
                          <th width="10%"><b>Status</b></th>
                          <th width="50%"><b>Responses</b></th>
                        </tr>
                        </thead>
                        <tbody>
                        <!-- Loop through cfEnterprise.steps -->
                        <tr v-for="(el, status_index) of statuses" :key="status_index">
                          <td class="text-left">
                            <div class="text-left">{{ el.text }}</div>
                          </td>
                          <td width="10%">
                            <span>
                              <i v-if="sloader === `${row.id}`" class="fa fa-spinner fa-spin text-info"></i>
                              <i v-else
                                 :class="row.cfEnterprise[el.key] === 'active' ? 'fa fa-check-circle text-success' :'fa fa-exclamation-circle text-warning'"
                                 :title="row.cfEnterprise[el.key]"></i>
                            </span>
                          </td>
                          <td class="text-center" width="50%">
                            <div class="text-left">
                              <!-- Show data in a JSON string or format as needed -->
                              <div v-if="viewResponce === `${row.id + el.key}`" class="json-container">
                                <pre v-if="row.cfEnterprise.checkStatuseResponse">
                                  {{ JSON.stringify(row.cfEnterprise.checkStatuseResponse, null, 2) }}
                                </pre>
                                <div v-else>
                                  We do not have stored responses for older data.
                                </div>
                              </div>
                              <div style="display: flex; justify-content: space-between">
                                <div>
                                  <a class="make-cursor-pointer text-primary"
                                     @click.prevent="viewResponce === `${row.id + el.key}` ? viewResponce = null : viewResponce = `${row.id + el.key}`">
                                    {{ viewResponce === `${row.id + el.key}` ? "Hide" : "View" }}
                                  </a>
                                  <!--                                 v-if="!row.cfEnterprise[el.key] || row.cfEnterprise[el.key] !== 'active'" -->
                                  <span class="mx-2">|</span>
                                  <a class="make-cursor-pointer text-primary"
                                     @click.prevent="recheckStatus(row, `${row.id}`)">
                                    Re-Check
                                  </a>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="row text-left">
                      <div class="col-md-12">
                        <h6><b>CheckList</b></h6>
                      </div>
                    </div>
                    <div>
                      <table class="table">
                        <thead>
                        <tr>
                          <th class="text-left">
                            <div class="text-left"><b>Task</b></div>
                          </th>
                          <th width="10%"><b>Is Checked</b></th>
                        </tr>
                        </thead>
                        <tbody v-if="row.cfEnterprise && row.cfEnterprise.cfEntChecklist">
                        <!-- Loop through cfEnterprise.steps -->
                        <tr v-for="(el, status_index) of row.cfEnterprise.cfEntChecklist" :key="status_index">
                          <td width="20%" class="text-left">
                            <div class="text-left">{{ el.text }}</div>
                          </td>
                          <td width="50%" class="text-center make-cursor-pointer">

                            <span :title="`Checked By: ${el.checkedBy}`" v-if="el.checkedBy">
                              <img width="30px" class="rounded-circle mr-4" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(el.checkedByEmail)}?s=100`">
                            </span>
                            <span v-else>
                              <input v-model="el.isChecked" @change="actionForCheckbox(row, el, status_index)" type="checkbox" class="">
                            </span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </section>
                </td>
              </tr>
              </tbody>
            </table>
            <template v-if="!sortedDomains.length && !loading">
              <div class="row">
                <div class="col-md-12 text-center text-danger mb-3 font-weight-bold">
                  No Domain Exists
                </div>
              </div>
            </template>
            <div v-if="!loading" class="row mt-10">
              <div class="col-md-12 d-flex justify-content-between align-items-center">
                <span class="lh-3 pull-left">
                  <b>Page {{ mainCurrentPage }} of {{ mainPageCount }}</b>
                </span>
                <section v-if="mainPageCount > 1" class="dataTables_paginate paging_full_numbers">
                  <paginate
                      id="notes"
                      :clickHandler="goToMainPage"
                      :nextText="'Next'"
                      :pageCount="mainPageCount"
                      :prevText="'Prev'"
                      containerClass="pagination"
                      next-class="page-item"
                      next-link-class="page-link"
                      page-class="page-item"
                      page-link-class="page-link"
                      prev-class="page-item"
                      prev-link-class="page-link">
                  </paginate>
                </section>
                <span v-else class="text-muted small"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Non-WPO Initiate Modal -->
    <div id="nonWpoModal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title">Initiate Boost for Non-WPO Domain</h6>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h6 class="mb-3"><b>Domain Details</b></h6>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Domain <span class="text-danger">*</span></label>
                <input v-model="nonWpoForm.domain" type="text" class="form-control form-control-sm" placeholder="example.com" />
              </div>
              <div class="form-group col-md-6">
                <label>Server IP <span class="text-danger">*</span></label>
                <input v-model="nonWpoForm.ip" type="text" class="form-control form-control-sm" placeholder="1.2.3.4" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>CF Plan <span class="text-danger">*</span></label>
                <select v-model="nonWpoForm.cf_plan" class="form-control">
                  <option value="performance_package">Performance Package</option>
                  <option value="performance_and_security_package">Performance & Security Package</option>
                  <option value="boost">Boost</option>
                  <option value="mediavine_integration">Mediavine Integration</option>
                </select>
              </div>
            </div>
            <hr />
            <h6 class="mb-3"><b>Cloudflare Details <small class="text-muted font-weight-normal">(optional)</small></b></h6>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>CF Email</label>
                <input v-model="nonWpoForm.cf_email" type="email" class="form-control form-control-sm" placeholder="user@example.com" />
              </div>
              <div class="form-group col-md-6">
                <label>API Key</label>
                <input v-model="nonWpoForm.cf_api_key" type="text" class="form-control form-control-sm" placeholder="Global API Key" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label>Zone ID</label>
                <input v-model="nonWpoForm.cf_zone" type="text" class="form-control form-control-sm" placeholder="Zone ID" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Nameserver 1</label>
                <input v-model="nonWpoForm.cf_ns1" type="text" class="form-control form-control-sm" placeholder="ns1.example.com" />
              </div>
              <div class="form-group col-md-6">
                <label>Nameserver 2</label>
                <input v-model="nonWpoForm.cf_ns2" type="text" class="form-control form-control-sm" placeholder="ns2.example.com" />
              </div>
            </div>
            <div v-if="nonWpoError" class="alert alert-danger py-2 mt-2" style="font-size:13px;">{{ nonWpoError }}</div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Cancel</button>
            <button class="btn btn-primary btn-sm" :disabled="nonWpoSaving" @click="submitNonWpo">
              <i v-if="nonWpoSaving" class="fa fa-spinner fa-spin mr-1"></i>
              {{ nonWpoSaving ? 'Creating...' : 'Create & Queue' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="view-log-modal">
      <div id="viewLogsModal" aria-hidden="true" class="modal fade" role="dialog" tabindex="-1">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title text-center">Log Details</h6>
              <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <section v-if="selectedLog.history !== undefined" class="mt-5">
                <!--                <code>-->
                <table class="table notesTable">
                  <thead>
                  <tr>
                    <th class="text-center">Output</th>
                    <th class="text-center">Status</th>
                    <th class="text-center">Activated At</th>
                    <th class="text-center">Deactivated At</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(row, index) in sortedHistory" :key="'note_' + index">
                    <td class="text-center" style="word-break: break-all" width="40%">{{ row.output }}</td>
                    <td class="text-center">
                      <span
                          :class="{'badge-success': row.status === 'pass', 'badge-danger': row.status === 'fail', 'badge-warning': row.status === 'removed'}"
                          class="badge">{{
                          row.status === 'pass' ? 'Activated' : (row.status === 'fail' ? 'Fail' : (row.status === 'removed' ? 'Deactivated' : ''))
                        }}</span>
                    </td>
                    <td class="text-center">
                      {{ row.activatedAt === 'N/A' ? 'Not enabled by WPO' : parseDate(row.activatedAt) }}
                    </td>
                    <td class="text-center">{{ parseDate(row.deactivatedAt) }}</td>
                  </tr>
                  </tbody>
                </table>
                <div v-if="selectedLog.history.length > 0 " class="row mt-10">
                  <div class="col-md-12 d-flex justify-content-between">
                    <span class="lh-3 pull-left">
                       <b>Page {{ pageNum + 1 }} of {{ pageCount }}</b>
                    </span>
                    <section class="dataTables_paginate paging_full_numbers">
                      <paginate
                          id="notes"
                          :clickHandler="goToPage"
                          :nextText="'Next'"
                          :pageCount="pageCount"
                          :prevText="'Prev'"
                          containerClass="pagination"
                          next-class="page-item"
                          next-link-class="page-link"
                          page-class="page-item"
                          page-link-class="page-link"
                          prev-class="page-item"
                          prev-link-class="page-link">
                      </paginate>
                    </section>
                  </div>
                </div>
                <!--                </code>-->
              </section>
              <code v-else>
                <ol style="list-style: none">
                  <li>{{ selectedLog.output }}</li>
                </ol>
              </code>
            </div>
            <div class="modal-footer">
              <button class="btn btn-secondary" data-dismiss="modal" type="button">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <activate-c-f-modal ref="activeCfModal"/>

  </div>
</template>

<script>
import moment from "moment";
import {db} from "@/firebase/init";
import swal from 'sweetalert2';
import Paginate from 'vuejs-paginate'
import ActivateCFModal from "@/components/Admin/Tasks/activateCFModal.vue";
import {getOrderedHostingDocs, isMultiDocUser} from '@/utils/firestoreUtils';
import axios from "axios";
import statisticsMixin from "@/mixins/statisticsMixin";
import md5 from "crypto-js/md5";

export default {
  name: "enterprise",
  mixins: [statisticsMixin],
  components: {ActivateCFModal, Paginate,},
  computed: {
    user() {
      return this.$store.getters.user;
    },
    tabCounts() {
      const counts = { pending: 0, inProgress: 0, complete: 0, deferred: 0, followUp: 0, failed: 0 };
      this.domains.forEach(row => {
        const cf = row.cfEnterprise || {};
        if (cf.status === 'failed') counts.failed++;
        if (cf.followUp) counts.followUp++;
        else if ((cf.status === 'fail') && !cf.checkinBy && !cf.resolvedBy) counts.deferred++;
        else if (cf.resolvedBy || (cf.status === 'pass' && !cf.resolvedBy)) counts.complete++;
        else if (cf.status === 'pending' && !cf.checkinBy) counts.pending++;
        else counts.inProgress++;
      });
      return counts;
    },
    tabFilteredDomains() {
      return this.domains.filter(row => {
        const cf = row.cfEnterprise || {};
        const isFollowUp = !!cf.followUp;
        const isComplete = !isFollowUp && (cf.resolvedBy || (cf.status === 'pass' && !cf.resolvedBy));
        const isPending = !isFollowUp && cf.status === 'pending' && !cf.checkinBy;
        const isDeferred = !isFollowUp && (cf.status === 'fail') && !cf.checkinBy && !cf.resolvedBy;
        const isInProgress = !isFollowUp && !isComplete && !isDeferred && !isPending;
        switch (this.activeTab) {
          case 'followUp': return isFollowUp;
          case 'deferred': return isDeferred;
          case 'complete': return isComplete;
          case 'inProgress': return isInProgress;
          case 'pending': return isPending;
          case 'failed': return cf.status === 'failed';
          default: return true;
        }
      });
    },
    inProgressCheckinAdmins() {
      const inProgressRows = this.domains.filter(row => {
        const cf = row.cfEnterprise || {};
        const isComplete = !!cf.resolvedBy || cf.status === 'pass';
        const isDeferred = cf.status === 'fail';
        const isInProgress = !isComplete && !isDeferred && (cf.status === 'running' || (cf.checkinBy && !cf.resolvedBy));
        return isInProgress && cf.checkinBy;
      });
      const byName = new Map();
      inProgressRows.forEach(row => {
        const name = row.cfEnterprise.checkinBy;
        const email = row.cfEnterprise.checkinByEmail || '';
        if (name && !byName.has(name)) byName.set(name, { name, email });
      });
      return Array.from(byName.values());
    },
    checkinFilteredDomains() {
      if (this.activeTab === 'pending' || this.checkinFilter === 'all') return this.tabFilteredDomains;
      return this.tabFilteredDomains.filter(row => (row.cfEnterprise || {}).checkinBy === this.checkinFilter);
    },
    planFilteredDomains() {
      if (!this.selectedPlanFilter || this.selectedPlanFilter === 'All') return this.checkinFilteredDomains;
      const planValue = this.planFilterToCfPlan[this.selectedPlanFilter];
      if (!planValue) return this.checkinFilteredDomains;
      return this.checkinFilteredDomains.filter(row => this.getRowPlanValue(row) === planValue);
    },
    planFilterToCfPlan() {
      return {
        'Boost': 'boost',
        'Mediavine Integration': 'mediavine_integration',
        'Performance': 'performance_package',
        'Performance and Security': 'performance_and_security_package'
      };
    },
    pageCount() {
      if (this.selectedLog && this.selectedLog.history && this.selectedLog.history.length > 0) {
        let filteredGroups = this.selectedLog.history
        let l = filteredGroups.length, s = this.pageSize;
        return Math.ceil(l / s);
      }
    },
    mainPageCount() {
      const l = this.sortedDomains ? this.sortedDomains.length : 0;
      const s = this.pageMainSize || 10;
      return Math.max(1, Math.ceil(l / s));
    },
    mainCurrentPage() {
      return Math.min(this.pageMainNum + 1, this.mainPageCount);
    },
    sortedHistory() {
      if (!this.selectedLog.history) {
        return []
      }
      const start = this.pageNum * this.pageSize, end = start + this.pageSize;
      const allTasks = this.selectedLog.history.slice(start, end);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return allTasks.sort((a, b) => new Date(b.activatedAt) - new Date(a.activatedAt))
      // return this.selectedLog.history ? this.selectedLog.history.sort((a, b) => new Date(b.activatedAt) - new Date(a.activatedAt)) : []
    },
    paginatedDomains() {
      const start = this.pageMainNum * this.pageMainSize, end = start + this.pageMainSize;
      const allTasks = this.sortedDomains.slice(start, end);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return allTasks
    },
      sortedDomains() {
      let domains = this.planFilteredDomains
      if (this.searchQuery) {
        domains = domains.filter(el => (el.domain && el.domain.includes(this.searchQuery.trim())) || (el.cfEnterprise.activatedAt && el.cfEnterprise.activatedAt.includes(this.searchQuery.trim())))
      }
      // const notActivatedByWPO =JSON.parse( JSON.stringify(domains.filter(el => el.cfEnterprise.activatedAt === 'Not enabled by WPO')));
      // const activatedByWPO = JSON.parse( JSON.stringify(domains.filter(el => el.cfEnterprise.activatedAt !== 'Not enabled by WPO')));
      // // console.log('sorted', this.domains.sort((a, b) => new Date(a.activatedAt) - new Date(b.activatedAt)))
      // const data = activatedByWPO.sort((a, b) => {
      //   if ('activatedAt' in a.cfEnterprise && 'activatedAt' in b.cfEnterprise) {
      //     return new Date(b.cfEnterprise.activatedAt) - new Date(a.cfEnterprise.activatedAt);
      //   } else if ('activatedAt' in a.cfEnterprise) {
      //     // If 'a' has 'activatedAt' and 'b' doesn't, 'a' comes before 'b'
      //     return -1;
      //   } else if ('activatedAt' in b.cfEnterprise) {
      //     // If 'b' has 'activatedAt' and 'a' doesn't, 'b' comes before 'a'
      //     return 1;
      //   } else {
      //     // If neither 'a' nor 'b' has 'activatedAt', maintain the original order
      //     return 0;
      //   }
      // }).concat(notActivatedByWPO);
      if (this.initial) {
        return domains.sort((a, b) => {
          const statusA = a.cfEnterprise.status || '';
          const statusB = b.cfEnterprise.status || '';

          const indexA = this.statusOrder.indexOf(statusA);
          const indexB = this.statusOrder.indexOf(statusB);

          // unknown statuses go last
          return (indexA === -1 ? 99 : indexA) - (indexB === -1 ? 99 : indexB);
        });
      } else {
        return domains
      }
    }
  },
  data() {
    return {
      updateIpLoader: {},
      updateIp: {},
      showItUID: 'KHLq1RjrpMT7aV0JY9fy2yrcYvT2',
      action: '',
      initial: true,
      searchQuery: '',
      loading: false,
      openTicketLoader: {},
      activeLoading: false,
      domains: [],
      selectedLog: {output: '',},
      listener: null,
      pageNum: 0,
      pageSize: 3,
      pageMainNum: 0,
      pageMainSize: 10,
      selectedIndex: -1,
      openDetails: null,
      viewResponce: null,
      sloader: null,
      activeTab: 'pending',
      priorityPlanFilters: ['All', 'Boost', 'Mediavine Integration', 'Performance', 'Performance and Security'],
      selectedPlanFilter: 'All',
      checkinFilter: 'all',
      statusOrder: ['pending', 'running', 'pass', 'fail','failed'],
      statuses: [{
        key: 'ssl_status',
        text: 'SSL Status'
      }, {
        key: 'hostname_status',
        text: 'Hostname Status'
      },
      //   {
      //   key: 'dns_status',
      //   text: 'DNS Status'
      // }, {
      //   key: 'change_origin_ip',
      //   text: 'Change Origin IP'
      // }, {
      //   key: 'cache_status',
      //   text: 'Cache Status'
      // }
      ],
      verifyDNSLoader: true,
      dnsVerification: false,
      verifyNameserverLoader: true,
      nameServerVerified: false,
      nonWpoForm: { domain: '', ip: '', cf_plan: 'boost', cf_email: '', cf_api_key: '', cf_zone: '', cf_ns1: '', cf_ns2: '' },
      nonWpoSaving: false,
      nonWpoError: '',
    }
  },
  beforeDestroy() {
    if (this.listener) {
      this.listener()
    }
  },
  watch: {
    domains() {
      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
    },
    searchQuery(newValue) {
      this.searchQuery = newValue.replace(/\s/g, '');
    },
    activeTab() {
      this.pageMainNum = 0;
    },
    selectedPlanFilter() {
      this.pageMainNum = 0;
    },
    checkinFilter() {
      this.pageMainNum = 0;
    }
  },
  async mounted() {
    await this.fetchActivatedCfEnterpriseDomains()
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
  },
  methods: {
    setTab(tab) {
      this.activeTab = tab;
    },
    getPlanFilterButtonClass(filter) {
      const isActive = this.selectedPlanFilter === filter;
      const colorMap = {
        'All': 'btn-secondary',
        'Boost': 'btn-primary',
        'Mediavine Integration': 'btn-success',
        'Performance': 'btn-info',
        'Performance and Security': 'btn-warning'
      };
      const baseClass = colorMap[filter] || 'btn-secondary';
      return isActive ? baseClass : `${baseClass} btn-link`;
    },
    /** Normalized plan value for filtering (cfPlan or primary.cloudflarePlan) */
    getRowPlanValue(row) {
      const plan = row.cfPlan;
      if (plan && typeof plan === 'string') return plan;
      const primary = row.primary && row.primary.cloudflarePlan;
      if (primary) {
        return Array.isArray(primary) ? primary[0] : primary;
      }
      return null;
    },
    async openTicketForBoostOrMediavineIntegrationPlan(row, index) {
      this.$set(this.openTicketLoader, row.id, true)
      const ref = await db.collection('users').doc(row.uid.split('_dup')[0]).get();
      let customerId = ''
      let firstName = ''
      if(ref.exists) {
        customerId = ref.data().customerID
        firstName = ref.data().firstName
      }
      let subject = '';
      let message = ''
      if(row.cfPlan === 'mediavine_integration') {
        subject = `Unable to Complete Setup of Mediavine Integration - ${row.domain}`
        message = `Hello ${firstName},\n\n We were unable to complete the activation of the Mediavine Integration for ${row.domain}. \n\nOur team is reviewing the setup details to determine the cause. We will reach out shortly if additional information (such as DNS access) is required.`
      } else if(row.cfPlan === 'boost') {
        subject = `Unable to Complete Boost Activation - ${row.domain}`
        message = `Hello ${firstName},\n\n We were unable to complete the activation of the Boost Addon for ${row.domain}.\n\n Our team is reviewing the setup details to determine the cause. We will reach out shortly if additional information (such as DNS access) is required.`
      }
      let response=await this.$http.post('host-bill/open-new-ticket', {
        grant_type: 'token',
        message: message,
        priority: 'Low',
        clientID: customerId,
        subject: subject,
        status: 'In-Progress',
        name: this.user.firstName + ' ' + this.user.lastName
      })
      if(response.data.success) {
        row.cfEnterprise.ticketId = response.data.ticket_id
        if(row.cfPlan === 'boost') {
          await this.$http.post('/host-bill/add-ticket-tag', {
            ticketId: response.data.ticket_id,
            grant_type: 'token',
            tag: `Boost`
          })
        }
        await db.collection('domains').doc(row.id).update({cfEnterprise: row.cfEnterprise});
      }
      this.$set(this.openTicketLoader, row.id, false)
      this.showToast({message: 'You have successfully created the ticket' , duration: 4000}, true, 'success')

    },
    emailHashGravatar(email) {
      if (!email) {
        return null
      } else {
        return md5(email.trim().toLowerCase()).toString()
      }
    },
    async actionForCheckbox(row, checked, index){
      console.log('event', row, checked.isChecked, index)
      try {
        row.cfEnterprise.cfEntChecklist[index] = {
          ...checked,
          checkedBy: checked.isChecked ? `${this.user.firstName} ${this.user.lastName}` : '',
          checkedByEmail: checked.isChecked ?  this.user.email : ''
        }
        console.log(row.cfEnterprise.cfEntChecklist)
        await db.collection('domains').doc(row.id).update({cfEnterprise: row.cfEnterprise});
      } catch (e) {
        console.log('errore', e)
      }

    },
    async checkDnsAndNameServer(row) {
      console.log('row', row, this.openDetails);

      this.verifyDNSLoader = true;
      this.verifyNameserverLoader = true
      if(this.openDetails !== row.id) return
      if(row.cfEnterprise.status === 'pending') {
        const apiData = await this.getCFData(row)
        console.log(apiData);
        this.verifyCloudFlare({ domain: row.domain, cloudflare: apiData})
        this.verifyNameservers({ domain: row.domain, cloudflare: apiData})
      }
      return true
    },
    async updateIP(row) {
      try {
        if(!row.cfEntIp) return
        this.$set(this.updateIpLoader, row.id, true)
        const resp = await axios.post('https://n8n.bigscoots.dev/webhook/lxd/cf-ent/update-dns-record', {
          "domain": row.domain,
          "new_ip": row.cfEntIp
        }, {
          headers: {
            Authorization: 'Bearer 8faa1397-5886-4187-be7b-468665ac39c7'
          }
        })
        console.log('resp', resp.data)
        if(resp.data.success){
          await this.getIp(row)
          this.showToast({message: `You have successfully updated IP` , duration: 2000}, true, 'success')
        }
      } catch (e) {
        console.log('error',e)
        row.cfEntResp = e
        await db.collection('vzToLxdMigration').doc(row.id).update({domains: row.domains})
        this.$set(this.updateIpLoader, row.id, false)
      } finally {

      }

    },
    async getIp(row) {
      try {
        this.$set(this.updateIpLoader, row.id, true)
        const resp = await axios.post('https://n8n.bigscoots.dev/webhook/cf-ent/manage-dns-record', {
          "domain": row.domain,
          action: 'get'
        }, {
          headers: {
            Authorization: 'Bearer 8faa1397-5886-4187-be7b-468665ac39c7'
          }
        })
        console.log('resp', resp.data)
        row.cfEntIp = resp.data.current_ip
        if(resp.data.success){
          await db.collection('domains').doc(row.id).update({ cfEntIp: row.cfEntIp})
          const ref = await db.collection('vzToLxdMigration').where('hostname', '==', row.hbHostname).get();
          if(ref.size) {
            const { domains } = ref.docs[0].data();
            const selectedDomain = domains.find(d => d.domain === row.domain)
            if(selectedDomain) {
              selectedDomain.cfEntIp = row.cfEntIp;
            }
            await db.collection('vzToLxdMigration').doc(ref.docs[0].id).update({domains})
          }
        }
      } catch (e) {
        console.log('error',e)
      } finally {
        this.$set(this.updateIpLoader, row.id, false)
        this.$set(this.updateIp, row.id, false)

      }

    },
    async triggerSwalForUpdateIp() {
      let ip = ''
      const self = this;
      const {value} = await swal.fire({
        title: "Update IP",
        input: "text",
        inputPlaceholder: "Enter IP",
        inputValue: ip,
        showCancelButton: true,
        confirmButtonText: 'Submit',
        inputValidator: (value) => {
          if (!value) {
            return "You need to add IP first!";
          }
        }
      });
      console.log('value', value)
      if(value) {

      }
    },
    async loginAsUser(data) {
      const domainRef = await db.collection('domains')
          .where('domain', '==', data.domain)
          .where('ip', '==', data.ip)
          .limit(1).get()
      let domainInfo = null
      if (domainRef.size > 0) {
        domainRef.forEach(el => {
          domainInfo = {id: el.id, ...el.data()}
        })
        console.log(domainInfo)
        window.open(`https://wpo.bigscoots.com/user/dashboard?id=${domainInfo.uid}`, 'WPO-Bigscoots');
      } else {
        swal('Error!', 'User not found!', 'error');
      }
    },
    openModal(data) {
      this.$emit('openModal', data);
    },
    async recheckStatus(row, key) {
      this.sloader = key
      try {
        await this.$http.post("provider/recheck-statuses", {
          grant_type: "token",
          docId: row.id,
        })
      } catch (e) {
        console.log('e', e.toString())
      }
      this.sloader = null
    },
    async resolveForcefully(row, key) {
      const {cfEnterprise} = row
      if (cfEnterprise.steps[key]) {
        cfEnterprise.steps[key].status = 'pass'
        cfEnterprise.steps[key].resolvedForcefully = `Resolved Forcefully by ${this.user.firstName} ${this.user.lastName}`;
      }
      const allSteps = Object.values(cfEnterprise.steps);
      const allSucceeded = allSteps.every(s => s.status === 'pass');
      const anyFailed = allSteps.some(s => s.status === 'fail');

      cfEnterprise.status = anyFailed ? 'fail' : allSucceeded ? 'pass' : 'running';
      cfEnterprise.activated = allSucceeded;
      cfEnterprise.activatedAt = allSucceeded ? new Date().toISOString() : '';
      await db.collection('domains')
          .doc(row.id)
          .update({
            cfEnterprise
          });
    },
    openNonWpoModal() {
      this.nonWpoForm = { domain: '', ip: '', cf_plan: 'boost', cf_email: '', cf_api_key: '', cf_zone: '', cf_ns1: '', cf_ns2: '' };
      this.nonWpoError = '';
      $('#nonWpoModal').modal('show');
      $('.modal-backdrop').removeClass('modal-backdrop');
    },
    async submitNonWpo() {
      this.nonWpoError = '';
      const { domain, ip } = this.nonWpoForm;
      if (!domain.trim()) { this.nonWpoError = 'Domain is required.'; return; }
      if (!ip.trim()) { this.nonWpoError = 'Server IP is required.'; return; }
      try {
        this.nonWpoSaving = true;
        const existing = await db.collection('domains')
          .where('domain', '==', domain.trim())
          .where('ip', '==', ip.trim())
          .limit(1)
          .get();
        if (!existing.empty) {
          this.nonWpoError = `A domain "${domain.trim()}" with IP "${ip.trim()}" already exists.`;
          return;
        }

        const docData = {
          uid: '',
          domain: domain.trim(),
          ip: ip.trim(),
          nonWpo: true,
          cloudflare: {
            email: this.nonWpoForm.cf_email || '',
            apiKey: this.nonWpoForm.cf_api_key || '',
            zone: this.nonWpoForm.cf_zone || '',
            nameserver1: this.nonWpoForm.cf_ns1 || '',
            nameserver2: this.nonWpoForm.cf_ns2 || '',
          },
          cfPlan: this.nonWpoForm.cf_plan,
          createdAt: new Date(),
          cfEnterprise: {
            status: 'pending',
            note: '',
          }
        };
        await db.collection('domains').add(docData);
        $('#nonWpoModal').modal('hide');
        swal({ title: 'Created!', text: `${domain.trim()} has been queued successfully.`, type: 'success', timer: 2500, showConfirmButton: false });
      } catch (e) {
        console.error('submitNonWpo error', e);
        this.nonWpoError = 'Something went wrong. Please try again.';
      } finally {
        this.nonWpoSaving = false;
      }
    },
    daysSince(val) {
      if (!val) return 0;
      const d = val.toDate ? val.toDate() : new Date(val);
      return Math.floor((Date.now() - d.getTime()) / 86400000);
    },
    formatStepTime(val) {
      if (!val) return '—';
      const d = val.toDate ? val.toDate() : new Date(val);
      return d.toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
    },
    sortedSteps(steps) {
      // Convert steps to an array, sort by `seq`, and return it
      return Object.entries(steps)
          .sort(([, a], [, b]) => a.seq - b.seq) // Sort by the `seq` property
          .map(([key, value]) => ({...value, key})); // Add the key back
    },
    renderDatatable() {
      console.log('rendering')
      if ($.fn.DataTable.isDataTable('#datatable')) {
        $("#datatable").DataTable().destroy();
      }
      $("#datatable").DataTable({
        ordering: false,
        retrieve: true,
        language: {
          search: "_INPUT_",
          searchPlaceholder: "Search",
          emptyTable: "No domain exists",
          size: '40'
        }
      });
    },
    goToPage(pageNum) {
      this.pageNum = pageNum - 1;
    },
    goToMainPage(pageNum) {
      this.pageMainNum = pageNum - 1;
    },
    viewLogs(log) {
      console.log(log);
      this.selectedLog = log;
      if (this.selectedLog.history) {
        this.selectedLog.history = this.selectedLog.history.reverse()
      }
      this.pageNum = 0;
      this.pageSize = 3;
      /* eslint-disable */
      $("#viewLogsModal").modal("show");
      $(document).ready(function () {
        $(".modal-backdrop").appendTo(".view-log-modal");
      });
      /* eslint-enable */
    },
    parseDate(date) {
      if (!date) {
        return null
      }
      return moment(date).format('DD MMM YYYY, hh:mm a')
    },
    async getCFData(row) {
      try {
        console.log('row', row)
        if (row.nonWpo) {
          const cf = row.cloudflare || {};
          return {
            email: cf.email || '',
            apikey: cf.apiKey || '',
            zone: cf.zone || '',
            nameserver1: cf.nameserver1 || '',
            nameserver2: cf.nameserver2 || '',
          };
        }

        const docsToFetch = isMultiDocUser(row.uid)
            ? await getOrderedHostingDocs(row.uid)
            : [db.collection('hostingAccounts').doc(row.uid)];

        const apiData = {};

        for (const docRef of docsToFetch) {
          const ref = await docRef.get();
          if (!ref.exists) continue;

          const {accounts} = ref.data();

          for (const acc of accounts) {
            if (acc.primary.domain === row.domain) {
              console.log('primary matched', acc.primary.domain);
              apiData.email = acc.primary.cloudflare.username || '';
              apiData.apikey = acc.primary.cloudflare.apiKey || '';
              apiData.zone = acc.primary.cloudflare.zone_id || '';
              apiData.nameserver1 = acc.primary.cloudflare.nameserver1 || '';
              apiData.nameserver2 = acc.primary.cloudflare.nameserver2 || '';
              return apiData;
            }

            for (const addon of acc.addon) {
              if (addon.domain === row.domain) {
                console.log('addon matched', addon.domain);
                apiData.email = addon.cloudflare && addon.cloudflare.username ? addon.cloudflare.username : acc.primary.cloudflare.username || '';
                apiData.apikey =  addon.cloudflare && addon.cloudflare.username ? addon.cloudflare.apiKey :  acc.primary.cloudflare.apiKey || '';
                apiData.zone = addon.cloudflare.zone_id || '';
                apiData.nameserver1 = addon.cloudflare.nameserver1 || '';
                apiData.nameserver2 = addon.cloudflare.nameserver2 || '';
                return apiData;
              }
            }
          }
        }
        console.log('api data got from cf ', apiData);
        return apiData;

      } catch (e) {
        console.log('error while fetching data', e.toString());
      }
    },
    async setCFPlanInHostingAccounts(data, from = false, changeStatus = false, deactivate = false) {
      this.initial = false;
      try {
        if (!data.cfPlan) {
          swal('Error', 'Please select CF Plan first', 'error');
          this.selectedIndex = -1;
          this.action = '';
          return false;
        }

        const docsToFetch = isMultiDocUser(data.uid)
            ? await getOrderedHostingDocs(data.uid)
            : [db.collection('hostingAccounts').doc(data.uid)];

        for (const docRef of docsToFetch) {
          const ref = await docRef.get();
          if (ref.exists) {
            const {accounts} = ref.data();

            for (const row of accounts) {
              // Match domain and server IP
              if (row.primary.domain === data.domain && row.primary.serverIP === data.ip) {
                row.primary.cloudflarePlan = data.cfPlan === 'mediavine_integration'
                    ? ['mediavine_integration']
                    : data.cfPlan;
                break;
              }

              const obj = row.addon.find(
                  el => el.domain === data.domain && row.primary.serverIP === data.ip
              );

              if (obj) {
                obj.cloudflarePlan = data.cfPlan === 'mediavine_integration'
                    ? ['mediavine_integration']
                    : data.cfPlan;
              }
            }

            await docRef.update({accounts});
          }
        }

        if (changeStatus) {
          data.cfEnterprise.status = 'pass';
        }

        if (data.cfPlan !== 'mediavine_integration' && !deactivate) {
          const response = await this.$http.post('/hostingAccounts/change-route-register-for-mediavine', {
            id: data.id,
            domain: data.domain,
            integrations: 'none',
            grant_type: 'token'
          });
          console.log(response);
        }

        await db.collection('domains').doc(data.id).update({
          cfPlan: data.cfPlan,
          cfEnterprise: data.cfEnterprise
        });

        if (from) {
          this.action = '';
          this.selectedIndex = -1;
          swal('Success', 'Plan has been changed successfully', 'success');
        }

      } catch (e) {
        this.action = '';
        this.selectedIndex = -1;
        console.log('error while setting CF plan data', e.toString());
      }
    },
    async deactivate(row, index) {
      this.initial = false
      this.action = 'deactivate';
      this.selectedIndex = index;
      try {
        const apiData = await this.getCFData(row)
        let buttonHtml = '<div class="swal-deactivate-content" style="text-align: left; max-width: 420px; margin: 0 auto;">' +
            '<p style="margin: 0 0 16px 0; color: #2d2d2d; line-height: 1.5; font-size: 14px;">Choose the services that you would like to terminate for this domain:</p>' +
            '<div style="background: #f8f9fa; border-radius: 8px; padding: 14px 16px; margin-bottom: 18px; border: 1px solid #e9ecef;">' +
            '<label style="display: flex; align-items: center; margin: 0 0 10px 0; cursor: pointer; font-size: 14px; color: #212529;">' +
            '<input type="checkbox" id="boost" style="margin: 0 10px 0 0; width: 16px; height: 16px; cursor: pointer;">' +
            '<span>Boost (Cloudflare Enterprise)</span></label>' +
            '<label style="display: flex; align-items: center; margin: 0 0 10px 0; cursor: pointer; font-size: 14px; color: #212529;">' +
            '<input type="checkbox" id="performance" style="margin: 0 10px 0 0; width: 16px; height: 16px; cursor: pointer;">' +
            '<span>Performance Setup</span></label>' +
            '<label style="display: flex; align-items: center; margin: 0; cursor: pointer; font-size: 14px; color: #212529;">' +
            '<input type="checkbox" id="security" style="margin: 0 10px 0 0; width: 16px; height: 16px; cursor: pointer;">' +
            '<span>Security Setup</span></label>' +
            '</div>' +
            '<div style="font-weight: 600; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px; color: #343a40; margin-bottom: 8px;">Details</div>' +
            '<table style="width: 100%; border-collapse: collapse; font-size: 13px; color: #212529;">' +
            `<tr style="border-bottom: 1px solid #eee;"><td style="padding: 6px 0; color: #495057; width: 100px;">Domain</td><td style="padding: 6px 0; word-break: break-all; color: #212529;">${row.domain}</td></tr>` +
            `<tr style="border-bottom: 1px solid #eee;"><td style="padding: 6px 0; color: #495057;">IP</td><td style="padding: 6px 0; color: #212529;">${row.ip || '—'}</td></tr>` +
            `<tr style="border-bottom: 1px solid #eee;"><td style="padding: 6px 0; color: #495057;">CF Email</td><td style="padding: 6px 0; word-break: break-all; color: #212529;">${apiData.email || '—'}</td></tr>` +
            `<tr><td style="padding: 6px 0; color: #495057;">CF API Key</td><td style="padding: 6px 0; word-break: break-all; color: #212529;">${apiData.apikey }</td></tr>` +
            '</table></div>'
        const result = await swal({
          title: "Choose Terminating Services",
          html: buttonHtml,
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057",
          preConfirm: () => {
            const el = id => document.getElementById(id)
            const terminateBoost = el('boost') ? el('boost').checked : false
            const terminatePerformance = el('performance') ? el('performance').checked : false
            const terminateSecurity = el('security') ? el('security').checked : false
            return this.$http.post("provider/deactivate_cf_enterprise", {
              grant_type: "token",
              domain: row.domain,
              email: apiData.email || '',
              apiKey: apiData.apikey || '',
              ip: row.ip,
              terminateBoost,
              terminatePerformance,
              terminateSecurity,
              deactivatedBy: `${this.user.firstName} ${this.user.lastName}`,
            }).then(async response => {
              console.log('response', response && response.data)
              const domainRef = await db.collection('domains').doc(row.id).get()
              row.cfEnterprise = domainRef.data().cfEnterprise
              row.cfEnterprise.checkinByEmail = ''
              row.cfEnterprise.checkinBy = ''
              if (!row.nonWpo) await this.setCFPlanInHostingAccounts({...row, cfPlan: 'free'}, false, false, true)
              return { response }
            }).catch(err => {
              return Promise.reject(err)
            })
          }
        })
        if (result.value) {
          await new Promise(r => setTimeout(r, 100))
          swal('Success', 'You have successfully deactivated CF Enterprise for ' + row.domain, 'success')
        }
        this.loading = false;
      } catch (e) {
        this.loading = false
        console.log('74', e.toString())
        swal('Error', `Something went wrong while deactivating CF Enterprise. ${e}`, 'error');
      } finally {
        this.action = '';
        this.selectedIndex = -1;
      }
    },
    async change020Status(row, index) {
      this.initial = false
      const flag = row.cfEnterprise.o2o_status ? 'disabled' : 'enabled';
      this.action = 'changeO2O';
      this.selectedIndex = index;
      swal({
        title: "Are you sure?",
        html: `Please note, O2O Status will be set to ${flag}.<br>Would you like to proceed?`,
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      }).then(async (result) => {
        if (result.value) {
          swal({
            title: "Processing...",
            html: "Please wait while we update the status.",
            allowOutsideClick: false,
            showConfirmButton: false,
            onOpen: () => {
              swal.showLoading();
            }
          });

          const status = row.cfEnterprise.o2o_status ? row.cfEnterprise.o2o_status : false;

          try {
            await this.$http.post("provider/change_o2o_status", {
              grant_type: "token",
              status: !status,
              domainData: row,
              domainId: row.id,
              hostingAccountId: row.uid
            });

            // Close loading alert
            swal.close();

            // Show success message
            await swal({
              title: "Success",
              html: `O2O has been ${flag} for <b>${row.domain}</b>`,
              type: "success",
            });
          } catch (error) {
            // Close loading alert and show error if any
            swal.close();
            swal({
              title: "Error",
              text: "Something went wrong. Please try again.",
              type: "error"
            });
          }
        }
      });
      this.action = '';
      this.selectedIndex = -1;

    },
    async retry(data, index) {
      this.initial = false
      this.action = 'retry';
      this.selectedIndex = index;
      try {
        console.log('1231', data)
        const apiData = await this.getCFData(data);
        let buttonHtml = '<div>' +
            '<div>Are you sure you want to deactivate Cloudflare Enterprise with following details? </div>' +
            '<br/>' +
            '<ul class="list-inline">' +
            `<li><b>Domain:</b> ${data.domain}</li>` +
            `<li><b>IP:</b> ${data.ip}</li>` +
            `<li><b>CF Email:</b> ${apiData.email}</li>` +
            `<li><b>CF API Key:</b> ${apiData.apikey}</li>` +
            '</ul></div>'
        const result = await swal({
          title: "Activate Cloudflare Enterprise!",
          html: buttonHtml,
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        })
        if (result.value) {
          console.log('api data', apiData);
          // const domainRef = await db.collection('domains').where('domain', '==', data.domain).where('ip', '==', data.ip).limit(1).get();
          // if(domainRef.size) {
          //   const {id} = domainRef.docs[0];
          //   const cfEnterprise = domainRef.docs[0].data().cfEnterprise || {}
          //   cfEnterprise.status = 'running'
          //   await db.collection('domains').doc(id).update({cfEnterprise});
          //
          // }
          const response = await this.$http.post("provider/initiate_cf_pkey", {
            grant_type: "token",
            domain: data.domain,
            username: apiData.email,
            apiKey: apiData.apikey,
            ip: data.ip,
            docId: data.id,
            initializedBy: `${this.user.firstName} ${this.user.lastName}`
          })
          console.log('response', response)
        }
      } catch (e) {
        console.log('error at 1266', e.toString())
        swal('Error', 'Something went wrong while processing of activating CF Enterprise', 'error');
      } finally {
        this.loading = false;
        this.action = '';
        this.selectedIndex = -1;
      }
    },
    async verifyNameservers (payload) {
      try {
        this.verifyNameserverLoader = true
        const wpoNameServers = [];
        const {cloudflare, domain} = payload;
        if(cloudflare && cloudflare.nameserver1){
          wpoNameServers.push(cloudflare.nameserver1)
        }
        if(cloudflare && cloudflare.nameserver2)
        {
          wpoNameServers.push(cloudflare.nameserver2)
        }
        let {data} = await this.$http.post('email/email-config/verify-dns', {
          cloudflare_email: cloudflare.username,
          cloudflare_api_key: cloudflare.apiKey,
          cloudflare_zone: cloudflare.zone_id,
          grant_type: 'token',
          domain,
          nameservers: wpoNameServers
        });
        console.log('response for Verify Nameservers',data.verified)
        this.nameServerVerified = data.verified || false
      } catch (e) {
        console.log(e.toString());
      } finally {
        this.verifyNameserverLoader = false
      }
    },
    async verifyCloudFlare (payload) {
      try {
        this.verifyDNSLoader = true
        const { cloudflare, domain } = payload;
        let {data} = await this.$http.post('email/verify-cloudflare', {
          cloudflare_email: cloudflare.email,
          cloudflare_api_key: cloudflare.apikey,
          cloudflare_zone: cloudflare.zone,
          grant_type: 'token',
          domain,
        });
        console.log('response for Cloud flare',data)
        this.dnsVerification= data.msg || false;
      } catch (e) {
        console.log(`error while veriying cloudflare ${e.toString()}`)
      } finally {
        this.verifyDNSLoader = false
      }
    },
    checkBeforeResolveTask (task) {
      const name = `${this.user.firstName} ${this.user.lastName}`;
      return task.checkinBy ? task.checkinBy !== name : false;
    },
    async checkin(row, index) {
      this.action = 'checkin';
      this.selectedIndex = index;
      row.cfEnterprise.checkinBy = `${this.user.firstName} ${this.user.lastName}`
      row.cfEnterprise.checkinByEmail = `${this.user.email}`
      await db.collection('domains').doc(row.id).update({cfEnterprise: row.cfEnterprise})
      this.action = ''
      this.selectedIndex = -1
    },
    async checkout(row, index) {
      try {
        this.action = 'checkout'
        this.selectedIndex = index
        row.cfEnterprise.checkinBy = ''
        row.cfEnterprise.checkinByEmail = ''
        await db.collection('domains').doc(row.id).update({ cfEnterprise: row.cfEnterprise })
        this.showToast({ message: 'Checked out successfully', duration: 3000 }, true, 'success')
      } catch (e) {
        console.log('error in checkout', e)
        this.showToast({ message: 'Something went wrong during checkout', duration: 3000 }, true, 'danger')
      } finally {
        this.action = ''
        this.selectedIndex = -1
      }
    },
    async moveToFollowUp(row, index, remove = false) {
      try {
        this.action = 'followUp'
        this.selectedIndex = index
        row.cfEnterprise.followUp = remove ? false : true
        await db.collection('domains').doc(row.id).update({ cfEnterprise: row.cfEnterprise })
        this.showToast({ message: remove ? 'Removed from Follow Up' : 'Moved to Follow Up', duration: 3000 }, true, 'success')
      } catch (e) {
        console.log('error in moveToFollowUp', e)
        this.showToast({ message: 'Something went wrong', duration: 3000 }, true, 'danger')
      } finally {
        this.action = ''
        this.selectedIndex = -1
      }
    },
    async resolve(row, index) {
      try {
        const {cfPlan} = row

        if (!row.nonWpo) {
          const emailResult = await swal.fire({
            title: 'Send Activation Email?',
            text: `Do you want to send an activation email to the client for ${row.domain}?`,
            type: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, Send Email',
            cancelButtonText: 'No',
            confirmButtonColor: '#3085d6',
          })

          if (emailResult.value) {
            try {
              let email = ''
              const ref = await db.collection('users').doc(row.uid.split('_dup')[0]).get()
              if (ref.exists) email = ref.data().email
              await this.$http.post('/provider/send-boost-email', {
                grant_type: 'token',
                domain: row.domain,
                userEmail: email,
                sendActivationEmail: true,
                cfPlan,
              })
            } catch (e) {
              console.log('error sending activation email', e)
              this.showToast({message: 'Failed to send activation email', duration: 3000}, true, 'danger')
            }
          }

          try {
            await this.$patchStackService.post('/sync-versions/wp_and_auto_updates', {
              grant_type: 'token',
              ip: row.ip,
              domain: row.domain,
            });
          } catch (e) {
            console.log('error in sync of cache', e)
          }
        }

        this.action = 'resolve';
        this.selectedIndex = index;
        row.cfEnterprise.resolvedBy = `${this.user.firstName} ${this.user.lastName}`
        row.cfEnterprise.resolvedByEmail = `${this.user.email}`
        row.cfEnterprise.resolvedAt = new Date().toISOString();
        row.cfEnterprise.status = 'pass'
        await db.collection('domains').doc(row.id).update({cfEnterprise: row.cfEnterprise})
        try{
          await this.incrementCountBasedOnType(this.user, 'support')
        }catch (e) {
          console.log('line 1023', e.toString())
        }
        this.showToast({message: 'You have successfully resolved the task' , duration: 4000}, true, 'success')

      } catch (e) {
        console.log('error while processing resolving record', e)
        this.showToast({message: 'Something went wrong while resolving CF Ent task' , duration: 4000}, true, 'danger')
      } finally {
        this.action = ''
        this.selectedIndex = -1
      }

    },
    async addChecklist(row, index) {
      try {
        const {cfPlan} = row

        this.action = 'addChecklist';
        this.selectedIndex = index;
        const ref = await db.collection('permissions').doc('cf-ent-activation-checklist').get();
        if(ref.exists) {
          const { checkList} = ref.data();

          const ref2 = await db.collection('domains').doc(row.id).get();
          if(ref2.exists) {
            const { cfEnterprise } = ref2.data();
            cfEnterprise.cfEntChecklist = checkList
            await db.collection('domains').doc(row.id).update({ cfEnterprise})
          }

        }
        this.showToast({message: 'Added checklist successfully!' , duration: 4000}, true, 'success')

      } catch (e) {
        console.log('error while processing resolving record', e)
        this.showToast({message: 'Something went wrong while adding CF Ent checklist' , duration: 4000}, true, 'danger')
      } finally {
        this.action = ''
        this.selectedIndex = -1
      }

    },

    async fetchActivatedCfEnterpriseDomains() {
      try {
        this.loading = true
        this.domains = []

        // Initial fetch: wait until all data is loaded from DB
        const snapshot = await db.collection('domains').where('cfEnterprise.status', 'in', this.statusOrder).get()
        snapshot.forEach(doc => {
          this.domains.push({ id: doc.id, ...doc.data() })
        })

        this.loading = false
        this.$nextTick(() => {
          $(function () {
            $('[data-toggle="tooltip"]').tooltip()
          })
        })

        // Live updates: attach listener for real-time changes (no loader)
        this.listener = db.collection('domains').where('cfEnterprise.status', 'in', this.statusOrder).onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(changeDoc => {
            if (changeDoc.type === 'added') {
              const exists = this.domains.some(el => el.id === changeDoc.doc.id)
              if (!exists) {
                this.domains.push({ id: changeDoc.doc.id, ...changeDoc.doc.data() })
              }
            }
            if (changeDoc.type === 'modified') {
              const selectedDomain = this.domains.find(el => el.id === changeDoc.doc.id)
              if (selectedDomain) {
                const data = changeDoc.doc.data();
                selectedDomain.cfEnterprise = { ...data.cfEnterprise };
                if (data.cfPlan !== undefined) selectedDomain.cfPlan = data.cfPlan;
              }
            }
            if (changeDoc.type === 'removed') {
              this.domains = this.domains.filter(el => el.id !== changeDoc.doc.id)
            }
          })
          this.$nextTick(() => {
            $(function () {
              $('[data-toggle="tooltip"]').tooltip()
            })
          })
        })
      } catch (e) {
        this.loading = false
        console.log('74', e.toString())
      }
    },
    async initiatePKeyProcess(row, index) {
      this.initial = false;
      this.activeLoading = row.id;
      this.action = 'initPKey';
      this.selectedIndex = index;

      try {
        console.log(`row ${JSON.stringify(row)}`);

        // Step 1: Set CF Plan (skip for non-WPO domains)
        if (!row.nonWpo) {
          await this.setCFPlanInHostingAccounts(row, false, row.cfEnterprise.previousStatus === 'pass');
        }

        // Step 2: If previously passed, skip
        if (row.cfEnterprise.previousStatus === 'pass') {
          if (row.cfPlan === 'mediavine_integration') {
            try {
              const response = await this.$http.post('/hostingAccounts/change-route-register-for-mediavine', {
                id: row.id,
                domain: row.domain,
                integrations: row.planName.toLowerCase().includes('journey') ? 'journey' : (row.planName.toLowerCase().includes('mediavine') ? 'mediavine' : 'none'),
                grant_type: 'token'
              })
              console.log('response of update integration', response.data)
            } catch (e) {
              console.log('error while updating integration', e.toString())
            }
          }
          return
        }


        let taskInfo = row;

        if (row.nonWpo) {
          // For non-WPO domains use cloudflare data directly from the domain doc
          taskInfo = { ...taskInfo, cloudflare: row.cloudflare || {} };
        } else {
          // Step 3: Get hosting account documents
          const docsToFetch = isMultiDocUser(row.uid)
              ? await getOrderedHostingDocs(row.uid)
              : [db.collection('hostingAccounts').doc(row.uid)];

          for (const docRef of docsToFetch) {
            const hostingAccountRef = await docRef.get();
            if (!hostingAccountRef.exists) continue;

            const {accounts} = hostingAccountRef.data();

            const obj = accounts.find(
                el =>
                    el.primary.domain === row.domain ||
                    !!el.addon.find(adon => adon.domain === row.domain)
            );

            if (obj) {
              if (obj.primary.domain === row.domain) {
                taskInfo = {...taskInfo, ...obj.primary};
              } else {
                const addon = obj.addon.find(el => el.domain === row.domain);
                if (addon) {
                  addon.serverIP = obj.primary.serverIP;
                  taskInfo = {...taskInfo, ...addon};
                }
              }
              break;
            }
          }
        }

        // Step 4: Send initiation request
        await this.$http.post('provider/initiate_cf_pkey', {
          grant_type: 'token',
          username: taskInfo.cloudflare.username || taskInfo.cloudflare.email || '',
          apiKey: taskInfo.cloudflare.apiKey || '',
          docId: row.id,
          initializedBy: `${this.user.firstName} ${this.user.lastName}`,
        });
        this.showToast({message: `You have successfully initialized activation process` , duration: 2000}, true, 'success')

      } catch (e) {
        console.log('Error:', e.toString());
      } finally {
        this.activeLoading = false;
        this.action = '';
        this.selectedIndex = -1;
      }
    }
  }
}
</script>

<style scoped>
code {
  background: #f4f4f4;
  border: 1px solid #ddd;
  border-left: 3px solid #2954fa;
  color: #666;
  page-break-inside: avoid;
  font-family: monospace;
  font-size: 12px;
  line-height: 1.6;
  margin-bottom: 1.6em;
  max-width: 100%;
  overflow: auto;
  padding: 1em 1.5em;
  display: block;
  word-wrap: break-word;
}

code .info {
  color: #376c4f;
}

code .danger {
  color: #cf363e;
}

.grey {
  opacity: 0.9;
}

.warning-bg {
  background-color: #fff9cb !important;
}

.bg-primary-light {
  background-color: #dbdbdb !important;
}


.details-control {
  background: url('../../../assets/img/details_open.png') no-repeat center center;
  cursor: pointer;
  width: 20px;
  height: 20px;
  display: block;
  margin: 13px auto;
}

.details-control.shown {
  background: url('../../../assets/img/details_close.png') no-repeat center center;
}

tr > th, td {
  padding: 4px 7px !important;
  text-align: center !important;
}

tr > th {
  font-size: 12px !important;
  font-weight: 400 !important;
}

.pagination {
  display: inline-flex !important;
}

.json-container {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-family: monospace;
  white-space: pre-wrap !important; /* Preserve line breaks for readability */
  word-wrap: break-word !important; /* Avoid overflow */
  max-width: 500px;
  overflow-wrap: break-word !important;
  overflow-x: auto;
}
.thead-dark {
  th{
    font-weight: bold !important;
    text-transform: capitalize !important;
  }
}

/* Status row + tabs (VzToLxd-style) */
.cf-ent-status-row {
  display: flex;
  align-items: stretch;
  flex-wrap: nowrap;
}

.cf-ent-status-row .col-md-3,
.cf-ent-status-row .col {
  display: flex;
  flex: 1 1 0;
  min-width: 0;
}

.status-item {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  cursor: pointer;
  border: 1.5px solid #e9ecef;
  border-left: 4px solid #e9ecef;
  border-radius: 8px;
  margin-right: 10px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  height: 100%;
  min-height: 90px;
  width: 100%;
}

.status-item-pending {
  border-color: #fbc658;
  background: linear-gradient(to right, rgba(251, 198, 88, 0.05), #ffffff);
}

.status-item-pending .status-label {
  color: #fbc658;
}

.status-item-inprogress {
  border-color: #51cbce;
  background: linear-gradient(to right, rgba(81, 203, 206, 0.05), #ffffff);
}

.status-item-inprogress .status-label {
  color: #51cbce;
}

.status-item-complete {
  border-color: #6bd098;
  background: linear-gradient(to right, rgba(107, 208, 152, 0.05), #ffffff);
}

.status-item-complete .status-label {
  color: #6bd098;
}

.status-item-deferred {
  border-color: #ff9800;
  background: linear-gradient(to right, rgba(255, 152, 0, 0.05), #ffffff);
}

.status-item-deferred .status-label {
  color: #ff9800;
}

.status-icon {
  font-size: 22px;
  margin-right: 14px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  flex-shrink: 0;
}

.status-icon-pending {
  color: #fbc658;
  background: rgba(251, 198, 88, 0.1);
}

.status-icon-inprogress {
  color: #51cbce;
  background: rgba(81, 203, 206, 0.1);
}

.status-icon-complete {
  color: #6bd098;
  background: rgba(107, 208, 152, 0.1);
}

.status-icon-deferred {
  color: #ff9800;
  background: rgba(255, 152, 0, 0.1);
}

.status-item-followup {
  border-color: #9c27b0;
  background: linear-gradient(to right, rgba(156, 39, 176, 0.05), #ffffff);
}

.status-item-followup .status-label {
  color: #9c27b0;
}

.status-icon-followup {
  color: #9c27b0;
  background: rgba(156, 39, 176, 0.1);
}

.status-item-failed {
  border-color: #dc3545;
  background: linear-gradient(to right, rgba(220, 53, 69, 0.05), #ffffff);
}

.status-item-failed .status-label {
  color: #dc3545;
}

.status-icon-failed {
  color: #dc3545;
  background: rgba(220, 53, 69, 0.1);
}

.status-content {
  flex: 1;
  min-width: 0;
}

.status-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-bottom: 4px;
  line-height: 1.3;
  word-wrap: break-word;
}

.status-count {
  font-size: 24px;
  font-weight: 700;
  color: #6c757d;
  line-height: 1.2;
  letter-spacing: -0.5px;
}

.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border: 0;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  border: 1px solid transparent !important;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff !important;
}

.nav-tabs .nav-item .nav-link.active {
  color: #5B7CFB;
}

.priority-filter-btn {
  margin-right: 0.5rem;
}
</style>

